<template>
  <!--begin::Advance Table Widget 2-->
  <div class="card card-custom card-stretch gutter-b">
    <!--begin::Header-->
    <div class="card-header border-0 pt-5">
      <h3 class="card-title align-items-start flex-column">
        <span class="card-label font-weight-bolder text-dark">
          List Permissions
        </span>
        <span class="text-muted mt-3 font-weight-bold font-size-sm">
          The total number of permissions right now : {{ permission.length }}
        </span>
      </h3>
      <div class="card-toolbar">
        <ul class="nav nav-pills nav-pills-sm nav-dark-75">
          <li class="nav-item mx-2">
            <b-button v-b-modal.modal-add-permission variant="info">create Permission</b-button>

            <b-modal
                id="modal-add-permission"
                title="Add New Permission"
                ref="modal-add-permission"
                hide-footer
                centered
                size="xl"
            >
              <b-form @submit.prevent="submitFormAddPermission" @reset="onResetFormAddRole" novalidate>

                <b-form-group
                    label="Permission Name:"
                    label-for="input-permission-name"
                    description="Enter the name of the permission."
                >
                  <b-form-input
                      id="input-permission-name"
                      v-model.trim="form_add_permission_info.name"
                      required
                      placeholder="Enter permission name"
                  ></b-form-input>
                </b-form-group>
                <b-form-group label="Source Key:"
                              label-for="input-source-key" id="input-source-key">
                  <b-row>
                    <b-col
                        v-for="(group, index) in chunkedSourceKeyList"
                        :key="index"
                        cols="12"
                        md="6"
                        lg="3"
                        class="mb-3"
                    >
                      <b-card>
                        <b-form-radio-group
                            v-model="form_add_permission_info.source_key"
                            :options="group"
                            stacked
                        />
                      </b-card>
                    </b-col>
                  </b-row>
                </b-form-group>
                <b-form-group label="Endpoints:"
                              label-for="input-endpoint-values">
                  <b-form-checkbox-group
                      v-model="form_add_permission_info.endpoint"
                      :options="list_endpoint_permission"
                      stacked
                  />
                </b-form-group>
                <b-form-group label="Source Values:"
                              label-for="input-source-values">
                  <b-form-checkbox-group
                      v-model="form_add_permission_info.source_value"
                      :options="list_source_value_permission"
                      stacked
                  />
                </b-form-group>

                <div class="d-flex justify-content-between mt-4">
                  <b-button type="reset" variant="outline-secondary">
                    Reset
                  </b-button>
                  <b-button type="submit" variant="primary">
                    Create Permission
                  </b-button>
                  <b-button variant="outline-danger" @click="hideModal">
                    Close
                  </b-button>
                </div>
              </b-form>
            </b-modal>


          </li>
          <li class="nav-item mx-2">
            <b-button variant="primary" @click="getPermission" ref="kt_list_update_permissions">Update</b-button>
          </li>

        </ul>
      </div>
    </div>

    <div class="card-body pt-3 pb-0">
      <b-modal
          id="modal-edit-permission"
          :title="`Edit Permission: ${form_edit_permission_info.id}`"
          ref="modal-edit-permission"
          hide-footer
          centered
          size="xl"
      >
        <b-form @submit.prevent="submitFormEditPermission" @reset="onResetFormEditPermission" novalidate>

          <b-form-group
              label="Permission Name:"
              label-for="input-permission-name"
              description="Enter the name of the permission."
          >
            <b-form-input
                id="input-permission-name"
                v-model.trim="form_edit_permission_info.name"
                required
                placeholder="Enter permission name"
            ></b-form-input>
          </b-form-group>

          <b-form-group
              label="Endpoints:"
              label-for="input-endpoints"
          >
            <b-form-checkbox-group
                id="input-endpoints"
                v-model="checkbox_selection_source_keys"
                :options="form_edit_permission_info.endpoint"
                stacked
            />
          </b-form-group>

          <b-form-group label="Fields:" label-for="input-source-value">
            <b-row>
              <b-col
                  v-for="(group, index) in chunkedFieldList"
                  :key="index"
                  cols="12"
                  md="6"
                  lg="3"
                  class="mb-3"
              >
                <b-card>
                  <b-form-checkbox-group
                      v-model="checkbox_selection_source_values"
                      :options="group"
                      stacked
                  />
                </b-card>
              </b-col>
            </b-row>
          </b-form-group>

          <div class="d-flex justify-content-between mt-4">
            <b-button type="reset" variant="outline-secondary">
              Reset
            </b-button>
            <b-button type="submit" variant="primary">
              Edit Permission
            </b-button>
            <b-button variant="outline-danger" @click="hideModal">
              Close
            </b-button>
          </div>
        </b-form>
      </b-modal>


      <!--begin::Table-->
      <div class="table-responsive">
        <table class="table table-hover table-bordered text-center align-middle">
          <thead class="thead-dark">
          <tr>
            <th class="fw-bold" style="width: 50px;">#</th>
            <th class="fw-bold">Name</th>
            <th class="fw-bold">Source Key</th>
            <th class="fw-bold">Source Values</th>
            <th class="fw-bold">Endpoint</th>
            <th class="fw-bold">Actions</th>
          </tr>
          </thead>
          <tbody>
          <template v-for="(item, i) in permission">
            <tr :key="i">
              <td>{{ i + 1 }}</td>

              <!-- Source Key -->
              <td class="text-center align-middle">
          <span class="text-dark fw-semibold">
            {{ item.name ?? '-' }}
          </span>
              </td>
              <td class="text-center align-middle">
          <span class="text-dark fw-semibold">
            {{ item.source_key ?? '-' }}
          </span>
              </td>

              <!-- Source Values -->
              <td class="text-start">
                <details>
                  <summary
                      class="fw-bold text-secondary"
                      @click.prevent="show_source_value(item.source_key, item.source_value)"
                      style="cursor: pointer"
                  >
                    Show Fields
                  </summary>
                  <div class="mt-2">
                    <span
                        v-for="(field, idx) in item.source_value"
                        :key="idx"
                        class="badge bg-info text-white mb-1 mr-1"
                    >
                      {{ field }}
                    </span>
                  </div>
                </details>
              </td>

              <!-- Endpoint -->
              <td class="text-start">
                <div v-if="item.endpoint">
                  <div class="mt-2">
                  <span v-for="perm in item.endpoint"
                        :key="perm"
                        class="badge bg-warning mr-1 mb-1 text-black">
                    {{ perm.split('/').slice(1).join('.') || perm }}
                  </span>
                  </div>
                </div>
                <span v-else class="badge bg-danger">No Access</span>
              </td>

              <!-- Actions -->
              <td class="text-center align-middle">
          <span
              class="mr-2"
              style="cursor: pointer;"
              v-b-tooltip.hover
              title="Edit Permission"
              @click="getPermissionInfo(i,item.source_key)"
          >
            <inline-svg src="media/svg/icons/Communication/Write.svg"></inline-svg>
          </span>
                <span
                    class="mr-2"
                    style="cursor: pointer;"
                    v-b-tooltip.hover
                    title="Delete Perm"
                    @click="deletePermissions(item.id, item.name)"
                >
                            <inline-svg src="media/svg/icons/General/Trash.svg"></inline-svg>
                          </span>
              </td>
            </tr>
          </template>
          </tbody>
        </table>


      </div>
      <!--end::Table-->
    </div>
    <!--end::Body-->
    <!--end::Advance Table Widget 2-->
  </div>
</template>
<script>
import {mapGetters} from "vuex";
import {
  ADD_PERMISSIONS, DELETE_PERMISSIONS, EDIT_PERMISSIONS,
  LIST_PERMISSIONS,
  LIST_ROLE_PERMISSIONS,
  SHOW_PERMISSIONS_INFO
} from "@/core/services/store/permissions.module";
import Swal from "sweetalert2";
import {CHANGE_USER_STATE} from "@/core/services/store/users.module";

export default {
  name: "table-permissions",
  data() {
    return {
      data: [],
      permission: [],
      role_data: [],
      form_add_permission_info: {
        name: "",
        endpoint: [],
        source_key: "",
        source_value: [],
        meta_data: [{}]
      },
      list_source_key_permission: [],
      list_endpoint_permission: [],
      list_source_value_permission: [],
      form_edit_permission_info: {
        id: 0,
        name: '',
        endpoint: [],
        source_key: '',
        source_value: []
      },
      checkbox_selection_source_values: [],
      checkbox_selection_source_keys: [],
    };
  },
  components: {},
  methods: {
    show_source_value(title, massage) {
      let text_html = '';
      massage.forEach((value, index) => {
        const displayValue = value.split('/').slice(1).join('.') || value;
        text_html += `
      <span
        class="badge bg-warning mr-1 mb-1 text-black"
        style="display: inline-block;"
      >
        ${displayValue}
      </span>`;
      });

      Swal.fire({
        title: title,
        icon: "question",
        html: text_html
      });
    },
    groupPermissions(endpoints) {
      const grouped = {};

      endpoints.forEach((endpoint) => {
        const parts = endpoint.split('/');
        const group = parts[0] || 'others';
        if (!grouped[group]) grouped[group] = [];
        grouped[group].push(endpoint);
      });

      return grouped;
    },
    showModalEditRole(id) {
      // این تابع را بر اساس نیاز خودتان کامل کنید
      console.log("Edit role with ID:", id);
    },
    getPermission() {
      const submitButton = this.$refs["kt_list_update_permissions"];
      submitButton.classList.add("spinner", "spinner-light", "spinner-right");
      this.$store.dispatch(LIST_PERMISSIONS).then((res) => {
        // console.log(res)
        this.permission = res
        this.permission.map((item, i) => {
          if (!this.list_source_key_permission.includes(item.source_key)) {
            this.list_source_key_permission.push(item.source_key)
          }
        })
        submitButton.classList.remove(
            "spinner",
            "spinner-light",
            "spinner-right"
        );
      }).catch(() => {
      });
    },
    deletePermissions(id, name) {
      Swal.fire({
        title: "Are you sure you want to delete the permission?",
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: "YES",
        denyButtonText: `NO`
      }).then((result) => {
        if (result.isConfirmed) {
          this.$store.dispatch(DELETE_PERMISSIONS, {id: id}).then((res) => {
            Swal.fire({
              icon: "success",
              title: `permission ${name} Deleted`
            });
            this.getPermission()
          });
        } else if (result.cancel) {
          Swal.fire("Not Deleted", "", "info");
        }
      });
    },
    getPermissionInfo(index, source_key) {
      this.$store.dispatch(SHOW_PERMISSIONS_INFO, {name: source_key}).then((res) => {
        this.form_edit_permission_info = this.permission[index];
        this.checkbox_selection_source_values = this.permission[index].source_value;
        this.checkbox_selection_source_keys = this.permission[index].endpoint;
        this.$refs['modal-edit-permission'].show();
        delete this.form_edit_permission_info.created_at;
      });
    },
    submitFormAddPermission() {
      if (this.form_add_permission_info.name == "") {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "please input all data",
        });
      } else {
        this.$store.dispatch(ADD_PERMISSIONS, this.form_add_permission_info).then((res) => {
          this.getPermission()
          this.onResetFormAddRole()
          this.$refs['modal-add-permission'].hide();
          Swal.fire({
            icon: "success",
            title: "Permission Added"
          });
        });
      }
    },
    submitFormEditPermission() {
      try {
        this.form_edit_permission_info.source_value = this.checkbox_selection_source_values;
        this.form_edit_permission_info.endpoint = this.checkbox_selection_source_keys;
        if (this.form_edit_permission_info.name == "") {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "please input all data",
          });
        } else {
          this.$store.dispatch(EDIT_PERMISSIONS, this.form_edit_permission_info).then((res) => {
            this.getPermission()
            this.onResetFormEditPermission()
            this.$refs['modal-edit-permission'].hide();
            Swal.fire({
              icon: "success",
              title: "Permission Edited"
            });
          });
        }
      } catch (e) {
        console.log(e)
      }
    },
    onResetFormAddRole() {
      document.querySelector("#input-source-key").classList.remove("d-none")
      this.form_add_permission_info.name = ''
      // this.form_add_permission_info.source_key = ''
      this.form_add_permission_info.endpoint = []
      this.form_add_permission_info.source_value = []
      this.list_source_value_permission = []
      this.list_endpoint_permission = []
    },
    onResetFormEditPermission() {
      this.form_edit_permission_info.name = ''
      this.form_edit_permission_info.endpoint = []
      this.form_edit_permission_info.source_key = []
      this.form_edit_permission_info.source_value = []
    },
    hideModal() {
      this.$refs['modal-add-permission'].hide()
      this.$refs['modal-edit-permission'].hide()
      this.onResetFormAddRole()
    }
  },
  computed: {
    getFullFieldList() {
      const match = this.permission.filter(p =>
          p.source_key === this.form_edit_permission_info.source_key
      );

      const sorted = match.sort((a, b) => b.source_value.length - a.source_value.length);
      return sorted.length ? sorted[0].source_value : [];
    },
    chunkedFieldList() {
      const chunkSize = 4;
      const list = this.getFullFieldList;
      const chunks = [];
      for (let i = 0; i < list.length; i += chunkSize) {
        chunks.push(list.slice(i, i + chunkSize));
      }
      return chunks;
    },
    chunkedSourceKeyList() {
      const chunkSize = 4;
      const list = this.list_source_key_permission;
      const chunks = [];
      for (let i = 0; i < list.length; i += chunkSize) {
        chunks.push(list.slice(i, i + chunkSize));
      }
      return chunks;
    },
    chunkedEndpointList() {
      const chunkSize = 4;
      const list = this.list_endpoint_permission;
      const chunks = [];
      for (let i = 0; i < list.length; i += chunkSize) {
        chunks.push(list.slice(i, i + chunkSize));
      }
      return chunks;
    },
    chunkedSourceValueList() {
      const chunkSize = 4;
      const list = this.list_source_value_permission;
      const chunks = [];
      for (let i = 0; i < list.length; i += chunkSize) {
        chunks.push(list.slice(i, i + chunkSize));
      }
      return chunks;
    },
    ...mapGetters(["layoutConfig"]),
  },
  watch: {
    'form_add_permission_info.source_key'(newVal) {
      this.$store.dispatch(SHOW_PERMISSIONS_INFO, {name: newVal}).then((res) => {
        this.list_source_value_permission = res.source_value
        this.list_endpoint_permission = res.endpoint
      });
      document.querySelector("#input-source-key").classList.add("d-none")
      // this.form_add_permission_info.source_key = ""
    }
  },
  mounted() {
    this.getPermission()
  }
};
</script>